import styled from 'styled-components'
import { Spin } from 'antd'

// Header Section
export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  // background-color: #f1f1f1;
  border-bottom: 1px solid #ccc;
`

// Title for the page
export const Title = styled.h1`
  font-size: 22px;
  font-weight: bold;
  color: #343e59;
  background-color: #f9fafe;
  margin: 0;
`

export const SubTitle = styled.h1`
  font-size: 16px;
  font-weight: 600;
  // font-size: px;
  // font-weight: bold;
  color: #000000;
  // background-color:#F9FAFE;
  margin-top: 3px;
  margin-bottom: 20px;
`
// Save Button Styles
export const SaveButton = styled.button`
  padding: 12px 30px;
  background-color: #808080;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`

// Page Content Wrapper
export const PageContent = styled.div`
  padding-top: 10px;
  height: 100vh;
  overflow-y: auto;
  margin-top: 3px;
`

// Main Container for sections
export const Container = styled.div`
  // padding: 20px 40px;
  // background-color: #fff;
  // margin-top: 10px;

    display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 142px);
  overflow: ${props => (props?.addNewCorporate ? 'none' : 'scroll')};
 padding: ${props => (props?.addNewCorporate ?  '0px' :'0px 40px 20px 40px')} ;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: #999;
    border-radius: 50px;
  }

`

// Section Title Styling
export const SectionTitle = styled.h2`
  font-size: 20px;
  color: #000000;
  margin-bottom: 15px;
`

// Company Details Section
export const CompanyDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 10px;

   input,
  select,
  textarea {
    // width: 500px;
    
    margin-top: 10px;
    border: 1px solid rgba(214, 219, 247, 1)
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0px 2px 6px 0px rgba(123, 97, 255, 0.15);
  }
`
export const CompanyContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => (props?.bottomSpace ? '30px' : '10px')};

  input,
  select,
  textarea {
    // width: 500px;
    
    margin-top: 10px;
    border: 1px solid rgba(214, 219, 247, 1)
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0px 2px 6px 0px rgba(123, 97, 255, 0.15);
  }
`
export const CompanySocialDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
 

  // input,
  // select,
  // textarea {
  //   // width: 500px;
  //   height: 45px;
  //   padding: 8px;
  //   margin-top: 5px;
  //   border: 1px solid #ccc;
  //   border-radius: 4px;
  //   box-sizing: border-box;
  // }
`
// File Upload Box Styling for Company Logo
export const FileUploadBox = styled.div`
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
  width: 570px;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

// Icon within Upload Box
export const UploadIcon = styled.div`
  font-size: 32px;
  margin-bottom: 5px;
  color: #007bff;
`

// Upload Box Text
export const UploadText = styled.div`
  font-size: 16px;
  color: #adadad;
`

// Format Description
export const UploadFormat = styled.div`
  font-size: 14px;
  color: #555;
`

// About Company Section Container
export const AboutCompanyContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: 30px;
  border-radius: 6px;
`

// Box for About Company Text Area
export const AboutCompanyBox = styled.div`
  border: 1px solid #ddd;
  padding: 16px;
  margin-top: 16px;
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  min-height: 150px; /* Set a minimum height to ensure box consistency */

  textarea {
    width: 100%;
    height: 100%;
    border: none;
    resize: none;
    outline: none;
    font-size: 14px;
    padding: 10px;
    box-sizing: border-box;
    background-color: #fff;
    color: #333;
    font-family: Arial, sans-serif;
  }
`

// Rich Text Options
export const RichTextOptions = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
  position: absolute;
  top: 10px;
  right: 10px;

  button {
    border: none;
    background-color: transparent;
    font-size: 16px;
    cursor: pointer;
    margin-left: 8px;
    color: #333;
    font-weight: bold;
  }

  button:hover {
    color: #000;
  }
`

// Dotted Box for POC
export const DottedBox = styled.div`
  border: 2px dotted #ccc;
  border-radius: 12px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  // width: 570px;
  position: relative;
`

// Add More Button Container
export const AddMoreDottedBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #ccc;
  padding: 3px;
  margin-top: 2px;
  flex-direction: column;
  cursor: pointer;
  width: 95%;
  border-radius: 8px;

  &:hover {
    background-color: #f0f0f0;
  }
`

// Button to Add More POC
export const AddMoreButton = styled.button`
  border: none;
  color: #007bff;
  font-size: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  background: rgba(249, 250, 254, 1);
  bottom: -20px;
  border: 1px dashed rgb(204, 204, 204);
  &:hover {
    color: #0056b3;
  }
  width: 90%;
  left: 5%;
  justify-content: center;
  border-radius: 10px;
  height: 45px;
`

// Add More Text
export const AddMoreText = styled.span`
  margin-left: 8px;
  font-size: 16px;
  color: #3249D7;
`

// About Title Styling
export const AboutTitle = styled.h3`
  font-size: 16px;
  color: ${props => props.color || '#000000'};
  margin-bottom: 5px;
`

// Section for Company Name and Other Info
export const LeftSection = styled.div`
  padding-right: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
`

// Section for Additional Information
export const RightSection = styled.div`
  width: 50%;
  padding-left: 20px;
`

export const BoxWithButton = styled.div`
  position: relative;
`

// Section Name for Individual Items
export const SectionName = styled.div`
  margin-bottom: 30px;
  padding: 20px;
  background: rgba(249, 250, 254, 1);
  border: 1px dashed rgba(214, 219, 247, 1);
  border-radius: 10px;
`

// Social Details Box Styling
export const SocialDetailsBox = styled.div`
  padding: 3px;
  margin-top: 3px;
  display: flex;
  align-items: center;
  height: 80px;
  border-radius: 8px;

  div {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 3px;
    margin-bottom: 3px;
    row-gap: 6px;
  }

  img {
    width: 30px; /* Adjust the size of the logo */
    height: 30px;
    margin-right: 10px;
  }

  input,
  select,
  textarea {
    margin-top: 10px;
    border: 1px solid rgba(214, 219, 247, 1)
    border-radius: 10px;
    box-sizing: border-box;
    box-shadow: 0px 2px 6px 0px rgba(123, 97, 255, 0.15);
  }
`

export const SocialDottedBox = styled.div`
  border: 2px dotted #ccc;
  padding: 2px;
  margin-top: 2px;
  display: flex;
  flex-direction: column;
  width: 570px;
  border-radius: 8px;
`
// Logo Preview Box
export const LogoPreview = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  width: 570px;
  border: 2px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
`

export const LogoImage = styled.div`
  width: 80px;
  height: 10px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e0e0e0;
`

export const LogoFileName = styled.div`
  flex: 1;
  font-size: 14px;
  color: #333;
`

export const DeleteButton = styled.button`
  background-color: #ff4d4d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e60000;
  }
`

export const Spinner = styled(Spin)`
  padding-top: 30%;
  position: absolute;
`